<template>
    <div class="filterButtons" role="group">
        <button type="button" class="btn home" :class="{ active: filter === 'all' }" @click="updateFilter ('all')"><i class="icon-home"></i></button>
        <button type="button" class="btn" :class="{ active: filter === 'weather' }"  @click="updateFilter ('weather')">Weather</button>
        <button type="button" class="btn" :class="{ active: filter === 'news' }"  @click="updateFilter ('news')">News</button>
        <button type="button" class="btn" :class="{ active: filter === 'social' }"  @click="updateFilter ('social')">Social</button>
    </div>
</template>

<script>
    export default {
      name: 'filter-buttons',
      computed: {
        filter () {
          return this.$store.getters.filter
        }
      },
      mounted: function () {
        // console.log('Filter Buttons')
      },
      methods: {
        updateFilter (filter) {
          this.$store.commit('FILTER_UPDATED', filter)
        }
      }
    }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/home/HomeFilterButtons.vue